<template>
	<v-sheet elevation="0">
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="pageTitle">
			<!-- app-barに表示するボタン群 -->
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn v-if="searchForms < 5" class="mr-2" color="secondary" @click="searchForms += 1"
					>検索項目追加{{ searchForms }}</v-btn
				>
				<!-- 検索フォーム用ダイアログ -->
				<SampleSearchDialog v-if="searchForms >= 5" text />

				<!-- 検索フォーム用メニュー (コピーするのは下のコメントアウトしたものをコピーすること) -->
				<v-menu v-else offset-y :close-on-content-click="false">
					<template v-slot:activator="{ on: menu, attrs }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip }">
								<v-btn color="primary" dark v-bind="attrs" v-on="{ ...tooltip, ...menu }">
									<v-icon class="mr-2">mdi-magnify</v-icon>検索
								</v-btn>
							</template>
							<span>5個未満はメニューまたは画面内フォーム<br />それ以降は別ダイアログ推奨。</span>
						</v-tooltip>
					</template>
					<v-card width="300px">
						<v-app-bar dense color="primary" flat>
							<v-app-bar-title class="color-white text-body-1 font-weight-bold"
								>絞り込み検索</v-app-bar-title
							>
						</v-app-bar>
						<v-card-text class="pa-2">
							<v-text-field
								v-for="n of searchForms"
								:key="n"
								:label="'テキスト'"
								dense
								outlined
								class="mt-4"
								hint="ここにヒントを表示"
							/>
							<v-row class="mt-4" no-gutters justify="center">
								<v-btn color="secondary">
									<v-icon class="mr-2">mdi-magnify</v-icon>
									検索する</v-btn
								>
							</v-row>
						</v-card-text>
					</v-card>
				</v-menu>

				<!-- 上のコードはtooltipのため、このコードをコピーすること -->
				<!-- <v-menu offset-y :close-on-content-click="false">
					<template v-slot:activator="{ on, attrs }">
						<v-btn color="primary" dark v-bind="attrs" v-on="on">
							<v-icon class="mr-2">mdi-magnify</v-icon>検索
						</v-btn>
					</template>
					<v-card width="300px">
						<v-app-bar dense color="primary" flat>
							<v-app-bar-title class="color-white text-body-1 font-weight-bold"
								>絞り込み検索</v-app-bar-title
							>
						</v-app-bar>
						<v-card-text class="pa-2">
							<v-text-field
								v-for="n of searchForms"
								:key="n"
								:label="'テキスト'"
								dense
								outlined
								class="mt-4"
								hint="ここにヒントを表示"
							/>
							<v-row class="mt-4" no-gutters justify="center">
								<v-btn color="secondary">
									<v-icon class="mr-2">mdi-magnify</v-icon>
									検索する</v-btn
								>
							</v-row>
						</v-card-text>
					</v-card>
				</v-menu> -->
	
				<!-- 新規作成ダイアログ -->
				<SampleNewDialog text />
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters class="mb-2" justify="end">
					<v-btn v-if="searchForms < 5" class="mr-2" color="secondary" @click="searchForms += 1"
						>検索項目追加{{ searchForms }}</v-btn
					>
					<!-- 検索フォームダイアログ app-bar下 -->
					<SampleSearchDialog v-if="searchForms >= 5" />
					<!-- 作成フォームダイアログ app-bar下 -->
					<SampleNewDialog />
				</v-row>
				<v-divider v-if="searchForms < 5" />
			</template>

			<!-- 絞り込み検索を画面上に表示しておく場合 4以下推奨-->
			<template
				v-if="(searchForms < 5 && searchForms > 2) || ($vuetify.breakpoint.xs && searchForms < 5)"
			>
				<v-row no-gutters :class="$vuetify.breakpoint.xs ? 'mt-2' : ''">
					<h3 class="text-h6 font-weight-bold">絞り込み検索</h3>
					<v-spacer />
					<v-switch
						color="primary"
						class="mt-0"
						v-model="showSearchForm"
						:label="showSearchForm ? 'フォームを隠す' : 'フォームを表示'"
						hide-details
					/>
				</v-row>
				<v-sheet v-if="showSearchForm" elevation="0">
					<v-row no-gutters class="mt-2">
						<v-col cols="12" sm="3" v-for="n of searchForms" :key="n">
							<v-text-field
								:label="'テキスト'"
								dense
								outlined
								class="mt-4 mx-1"
								hint="ここにヒントを表示"
							/>
						</v-col>
						<v-col v-if="searchForms <= 3 && !$vuetify.breakpoint.xs" cols="12" sm="3">
							<v-btn color="secondary" class="mt-4 mx-1">
								<v-icon class="mr-2">mdi-magnify</v-icon>
								検索する</v-btn
							>
						</v-col>
					</v-row>
					<v-row
						no-gutters
						justify="center"
						class="mt-2 mb-4"
						v-if="
							(!$vuetify.breakpoint.xs && searchForms == 4) ||
							($vuetify.breakpoint.xs && searchForms < 5)
						"
					>
						<v-btn color="secondary">
							<v-icon class="mr-2">mdi-magnify</v-icon>
							検索する</v-btn
						>
					</v-row>
				</v-sheet>
				<v-divider />
			</template>

			<!-- 一覧画面部分 -->
			<div class="table-container px-2 mt-4">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="items"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
					@click:row="showDialog"
				/>
			</div>
			<PaginationModule :pagination="pagination" />
		</CommonFlame>
		<SampleShowDialog v-if="selectedItem" :item="selectedItem" @close="selectedItem = null" />
	</v-sheet>
</template>
<script>
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../shared/PaginationModule.vue"
import SampleNewDialog from "./components/SampleNewDialog.vue"
import SampleShowDialog from "./components/SampleShowDialog.vue"
import SampleSearchDialog from "./components/SampleSearchDialog.vue"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
		SampleShowDialog,
		SampleSearchDialog,
		SampleNewDialog,
		PaginationModule,
	},
	data() {
		return {
			mainTitle: "部門名・項目名",
			pageTitle: "SampleIndexPage.vue",
			selectedItem: null,
			showSearchForm: true,
			searchForms: 1,
			// widthを自分で設定すること
			headers: [
				{ text: "項目1", value: "text1", width: "200px" },
				{ text: "項目2", value: "text2", width: "200px" },
				{ text: "項目3", value: "text3", width: "200px" },
				{ text: "項目4", value: "text4", width: "200px" },
				{ text: "項目5", value: "text5", width: "200px" },
				{ text: "項目6", value: "text6", width: "200px" },
				{ text: "項目7", value: "text7", width: "200px" },
				{ text: "項目8", value: "text8", width: "200px" },
			],
			// ページネーションの値はサンプル
			pagination: {
				count: 5,
				current: 1,
				limit_value: 5,
				next: 2,
				pages: 50,
				previous: null,
			},
		}
	},
	methods: {
		showDialog(item) {
			this.selectedItem = item
		},
	},
	computed: {
		items() {
			const array = []
			for (let i = 0; i < 50; i++) {
				array.push({
					text1: `テキスト${i}-1`,
					text2: `テキスト${i}-2`,
					text3: `テキスト${i}-3`,
					text4: `テキスト${i}-4`,
					text5: `テキスト${i}-5`,
					text6: `テキスト${i}-6`,
					text7: `テキスト${i}-7`,
					text8: `テキスト${i}-8`,
				})
			}
			return array
		},
	},
}
</script>